// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"355":"25e93d8c","594":"801cbdfc","683":"160a782d"}[chunkId] + ".css";
};